<div class="dashboard-container">
  <via-dashboard></via-dashboard>
</div>
